import Button from "components/Elements/Button/Button.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import SimpleContent from "components/Structure/ModalManager/SimpleContent.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import React, { useState } from "react";

import "./UpgradeToBusinessModal.scss";

const UpgradeToBusinessModal = () => {
  const { getTextByKey } = useContent();

  return (
    <SimpleContent
    title="sub-user-not-availabe-title"
    message="sub-user-not-availabe-message"
    actionButton={
    <LinkToNewTab page="purchase/business/yearly" isNewTab={true}>
        <Button>{getTextByKey("profileuser-upgrade-usage")}</Button>
    </LinkToNewTab>
    }
    additonalModalClass={"sub-user-not-availabe-modal"}
    ></SimpleContent>
  );
};

export default UpgradeToBusinessModal;






